import { useTranslation } from 'react-i18next';
import type { RoundProgress } from './roundProgress';
import { toAnnualValueLeftPercentage, toHandledPercentage } from './worksheetCalculations';

interface RoundProgressSummaryProps {
    progress: RoundProgress;
}

const RoundProgressSummary = ({ progress }: RoundProgressSummaryProps) => {
    const { t } = useTranslation();

    return (
        <span>
            <span className="semibold">{t('priceSimulation.plansLeft', { count: progress.total, left: progress.total - progress.done })}</span>
            <span className="text-secondary"> · {t('priceSimulation.percentHandled', { percent: toHandledPercentage(progress.done, progress.total) })}</span>
            {progress.currentAnnualValue > 0 && (
                <span className="text-secondary">
                    {' '}
                    · {t('priceSimulation.annualValueLeft', { percent: toAnnualValueLeftPercentage(progress.handledAnnualValue, progress.currentAnnualValue) })}
                </span>
            )}
        </span>
    );
};

export default RoundProgressSummary;
